import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Auswahlfeld (MUI-`Select`-Ersatz) auf Basis eines nativen `<select>` mit
 * `.sec-select`-Optik — voll tastatur-/screenreader-zugaenglich. Optionen via
 * `<MenuItem value=…>`.
 */
export const Select = forwardRef(function Select({ className, ...rest }, ref) {
    return _jsx("select", { ref: ref, className: cn('sec-select', className), ...rest });
});
/** Option innerhalb von `<Select>` (MUI-`MenuItem`-Ersatz → natives `<option>`). */
export const MenuItem = forwardRef(function MenuItem({ ...rest }, ref) {
    return _jsx("option", { ref: ref, ...rest });
});
